import { useParams, Link } from "react-router-dom";
import { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import frontMatter from "front-matter";

export default function ArticlePage() {
  const { slug } = useParams();
  const [frontmatter, setFrontmatter] = useState({});
  const [markdownBody, setMarkdownBody] = useState("");
  const [error, setError] = useState(false);

  useEffect(() => {
    const path = `/articles/${slug}.md`;
    console.log("📁 Fetching markdown:", path);

    fetch(path)
      .then((res) => {
        if (!res.ok) throw new Error("Markdown file not found");
        return res.text();
      })
      .then((text) => {
        const parsed = frontMatter(text);
        setFrontmatter(parsed.attributes);
        setMarkdownBody(parsed.body);
        setError(false);
      })
      .catch((err) => {
        console.error("❌ Error loading markdown:", err);
        setError(true);
      });
  }, [slug]);

  const currentUrl = `${window.location.origin}/stories/${slug}`;

  if (error) {
    return (
      <div className="max-w-3xl mx-auto px-4 py-12 text-center text-red-600">
        <p className="text-lg font-semibold">❌ This story could not be loaded.</p>
        <Link
          to="/"
          className="text-purple-600 hover:underline text-sm mt-4 inline-block"
        >
          ← Back to Stories
        </Link>
      </div>
    );
  }

  return (
    <div className="max-w-3xl mx-auto px-4 py-12">
      <Link
        to="/"
        className="inline-block text-purple-600 mb-4 hover:underline text-sm"
      >
        ← Back to Stories
      </Link>

      <article className="prose prose-lg prose-purple dark:prose-invert">
        {frontmatter.title && <h1>{frontmatter.title}</h1>}
        {(frontmatter.author || frontmatter.date) && (
          <p className="text-sm text-gray-500 mt-[-1rem] mb-4">
            {frontmatter.author && <span>By {frontmatter.author}</span>}
            {frontmatter.date && (
              <span> • {new Date(frontmatter.date).toLocaleDateString()}</span>
            )}
          </p>
        )}

        <ReactMarkdown>{markdownBody}</ReactMarkdown>
      </article>

      {frontmatter.tags && (
        <div className="mt-6 flex flex-wrap gap-2">
          {frontmatter.tags.map((tag) => (
            <span
              key={tag}
              className="bg-purple-100 text-purple-800 text-xs font-medium px-3 py-1 rounded-full"
            >
              #{tag}
            </span>
          ))}
        </div>
      )}

      <div className="mt-8 pt-4 border-t border-gray-200">
        <h3 className="text-lg font-semibold mb-2">Share this story on:</h3>
        <div className="flex gap-4 flex-wrap">
          <a
            href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(
              currentUrl
            )}&text=${encodeURIComponent(frontmatter.title || "Read this!")}`}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-500 hover:underline text-sm"
          >
            Twitter
          </a>
          <a
            href={`https://wa.me/?text=${encodeURIComponent(
              frontmatter.title + " - " + currentUrl
            )}`}
            target="_blank"
            rel="noopener noreferrer"
            className="text-green-600 hover:underline text-sm"
          >
            WhatsApp
          </a>
          <a
            href={`https://www.linkedin.com/shareArticle?url=${encodeURIComponent(
              currentUrl
            )}&title=${encodeURIComponent(frontmatter.title || "")}`}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-700 hover:underline text-sm"
          >
            LinkedIn
          </a>
        </div>
      </div>
    </div>
  );
}
